  <template>
    <div class="bg-gray-100">

        <tti-header class="shadow-sm" :is-logged-in="true"></tti-header>

<div v-if="user">

  <main class="relative mt-8">
    <div class="max-w-screen-xl mx-auto pb-6 px-4 sm:px-6 lg:pb-16 lg:px-8">

      <div class="bg-white rounded-lg shadow">
        <div class="divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">
          <aside class="py-6 lg:col-span-3">
            <div class="lg:hidden px-6">
              <label for="tabs" class="text-sm text-gray-600">Navigate to…</label>
              <select v-bind:value="this.$route.path" @change="onSelectNavChange($event.target.value)" id="tabs" name="tabs" class="block w-full mt-1 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md">
                  <option v-for="link in navLinks" :key="link.url" :value="link.url">{{ link.title }}</option>
              </select>
            </div>
            <nav class="hidden lg:block space-y-1">
                <tti-navlink v-for="link in navLinks" :key="link.url" :to="link.url" :icon="link.icon" :heroicon="link.heroicon" :notification="link.notification">{{ link.title }}</tti-navlink>
            </nav>
          </aside>

          <div class="lg:col-span-9">
            <div class="">
              
              <router-view :progress-complete="progressComplete"></router-view>

            </div>
          </div>
          
        </div>
      </div>
    </div>
  </main>
</div>

<p class="mb-6 lg:mb-10 px-3 text-gray-600 text-center">Questions or feedback? <a href="mailto:hello@thetutorindex.com" class="text-blue-600 underline">We’d love to hear from you</a></p>

<tti-footer></tti-footer>

<tailwind-notification></tailwind-notification>

</div>
</template>
<script>

import { ChatAlt2Icon, CheckIcon } from '@vue-hero-icons/solid'
import { ShieldCheckIcon, ViewGridIcon, IdentificationIcon, StarIcon, PlusIcon, DocumentTextIcon, } from '@vue-hero-icons/solid'

import UserService from '../services/UserServices';
const userService = new UserService();

import EnquiryService from '../services/EnquiryServices';
const enquiryService = new EnquiryService();

export default {
    components: {
      CheckIcon,
      'heroicon': () => import('./Heroicon'),
      'tti-header': () => import('./HeaderNew'),
      'tti-footer': () => import('./Footer'),
      'tti-navlink': () => import('./EditTutor-NavLink'),
      'tti-button': () => import('./TailwindButton.vue'),
      'tailwind-notification': () => import('./TailwindNotification')
    },
    data() {
        return {
            authCheckerTimer: null
        }
    },
    computed: {
      user() {
        return this.$store.getters.user
      },
      navLinks() {
        const links = [
          { url: '/my-account/', title: 'Overview', heroicon: ViewGridIcon },
          { url: '/my-account/profile', title: 'Profile', icon: 'user-circle' },
          { url: '/my-account/enquiries', title: 'Enquiries', icon: this.$store.state.numberOfUnseenEnquiries > 0 ? 'inbox-in' : 'inbox', notification: this.$store.state.numberOfUnseenEnquiries },
          { url: '/my-account/subjects', title: 'Subjects', icon: 'academic-cap' },
          { url: '/my-account/qualifications', title: 'Qualifications', icon: 'diploma' },
          { url: '/my-account/locations', title: 'Locations', icon: 'location-marker' },
          { url: '/my-account/rate-card', title: 'Rate Card', icon: 'currency-pound' },
          { url: '/my-account/interview', title: 'Interview', heroicon: ChatAlt2Icon },
          { url: '/my-account/subscription', title: 'Subscription', heroicon: PlusIcon },
          { url: '/my-account/id-check', title: 'ID Check', heroicon: IdentificationIcon },
          { url: '/my-account/dbs-check', title: 'DBS Check', heroicon: ShieldCheckIcon },
          { url: '/my-account/kcsie', title: 'KCSIE', icon: 'hands-holding-child' },
          { url: '/my-account/online-payments', title: 'Online Payments', icon: 'credit-card' },
          { url: '/my-account/references', title: 'References', icon: 'user-check' },
          { url: '/my-account/testimonials', title: 'Testimonials', heroicon: StarIcon },
          { url: '/my-account/articles', title: 'Articles', heroicon: DocumentTextIcon },
          { url: '/my-account/security', title: 'Account', icon: 'key' },
        ]

        return links
      },
      progress() {
        return [
          // { title: 'Add your name.', complete: !!this.user.Name },
          // { title: 'Upload a profile photo.', complete: !!this.user.Photo },
          // { title: 'Introduce yourself in your bio.', complete: !!this.user.Bio },
          // { title: 'Describe your approach to teaching.', complete: !!this.user.ApproachToTeaching },
          // { title: 'Explain your previous teaching experience.', complete: !!this.user.TeachingExperience },
          // { title: 'List the subjects you teach.', complete: !!this.user.SubjectsTaught.length > 0 },
          // { title: 'Specify where you teach.', complete: this.user.Locations.length > 0 || this.user.TeachesOnline },
          // { title: 'Provide information about the rate you charge.', complete: !!this.user.RateFrom },
          // { title: 'Send and receive a test enquiry email.', complete: this.user.HasViewedTestEnquiryEmail },
        ]
      },
      progressComplete() {
        return this.progress.every(x => x.complete) || this.user.Published
      }
    },
    methods: {
        onSelectNavChange(link) {
            this.$router.push(link);
        },
        redirectToSignIn() {
          clearInterval(this.authCheckerTimer);
          localStorage.removeItem('token');
          this.$router.push({ path: '/sign-in', query: { expired: true } });
        },
        publishProfile() {
            this.$store.dispatch('updateUser', { Published: true }).then(() => {
                this.$store.commit('showModal', { icon: 'check-circle', title: 'Profile published.' });
            });
        }
    },
    async mounted() {
      try {
        await this.$store.dispatch('refreshUser')
      }
      catch {
        // Probably not authencticated
        this.redirectToSignIn()
      }
        
      // Configure timer to regularly check they are logged in
      this.authCheckerTimer = setInterval(() => {
        userService.ping().catch(() => this.redirectToSignIn())
      }, 10000);

      this.$store.dispatch('getNumberOfUnseenEnquiries')

      if (this.$route.query.passwordreset === '1') {
        this.$store.commit('showModal', { icon: 'check-circle', title: 'Your password has been updated.' });
      }
    }
}
</script>